import React from 'react';
import { shape, string } from 'prop-types';
import LOADER from '@/assets/animation/loader.gif';

/**
 * Loader animation with gif
 * @deprecated use LoaderAnimate instead
 *
 * @param {*} props
 * @returns
 */
const LoaderGif = (props) => {
  const { style, ...rest } = props;
  return (
    <div style={style} {...rest}>
      <img src={LOADER} style={{ width: 50 }} alt="loader" />
    </div>
  );
};

LoaderGif.propTypes = {
  color: string,
  style: shape({}),
};

LoaderGif.defaultProps = {
  color: null,
  style: null,
};

export default LoaderGif;
